export default document.querySelector('meta[name="csrf-token"]')?.attributes?.content?.value
